import styled from '@xstyled/styled-components';

export default styled.div`
  display: flex;
  min-width: minLayoutWidth;
  height: 100%;
  flex-direction: column;
`;
